var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"ticker",staticClass:"c-news-ticker"},[_c('span',{ref:"line",staticClass:"c-news-line c-news-ticker__line",class:_vm.lineClass,attrs:{"aria-live":_vm.$viewModel.srAnnounceNews ? 'polite': null},on:{"click":_vm.onLineClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }